<h1 mat-dialog-title *ngIf="!atWelcome" i18n>First Steps</h1>
<div mat-dialog-content>
  <div *ngIf="atWelcome">
    <!-- <div class="languageOptions">
      <mat-form-field>
        <mat-select
          value="{{ _session.getCurrentLocale() }}"
          placeholder="Language (Sprache)"
          #languageSelect
          (selectionChange)="changeLanguageVersion(languageSelect.value)"
        >
          <mat-option value="de">German (Deutsch)</mat-option>
          <mat-option value="en">English (Englisch)</mat-option>
        </mat-select>
      </mat-form-field>
    </div> -->
    <h1 class="greeting" i18n>
      <span class="toolNameSpan">Welcome</span> to the convOERter!
    </h1>
    <img
      class="logo"
      src="assets/oer-logo-4.png"
      height="130"
      width="130"
      alt="Logo"
    />
    <p class="welcomeText" i18n>
      This web app allows you to easily convert existing documents or
      presentations into Open Educational Resources (OER).
    </p>
    <div class="oerInfos">
      <a
        href="https://creativecommons.org/about/program-areas/education-oer/"
        target="_blank"
        i18n
        i18n-href
        >What is OER?</a
      >
      <!-- <a href="https://open-educational-resources.de/was-ist-oer-3-2/" target="_blank">Was ist OER? (German)</a> -->
    </div>

    <mat-list style="margin-top: 0; padding-top: 0">
      <h2 style="margin-bottom: 0; margin-top: 0.8rem" i18n>How it works</h2>
      <mat-list-item class="autoHeight">
        <mat-icon mat-list-icon>grid_view</mat-icon>
        <div mat-line i18n>Image Overview</div>
        <div class="allowWrap" mat-line i18n>
          The convOERter detects all images embedded in the file and lists them for further processing.
        </div>
      </mat-list-item>
      <mat-list-item class="autoHeight">
        <mat-icon mat-list-icon>account_tree</mat-icon>
        <div mat-line i18n>Decide Yourself</div>
        <div class="allowWrap" mat-line i18n>
          For each image, <i>you</i> can decide to replace it, mark it as your
          own work or exclude it from the overall license.
        </div>
      </mat-list-item>
      <mat-list-item class="autoHeight">
        <mat-icon mat-list-icon>image_search</mat-icon>
        <div mat-line i18n>Find Replacements</div>
        <div class="allowWrap" mat-line i18n>
          If you decide to replace an image, you can search through large
          datasets of images with a Creative Commons license to find a good
          replacement.
        </div>
      </mat-list-item>
      <mat-list-item class="autoHeight">
        <mat-icon mat-list-icon>lock</mat-icon>
        <div mat-line i18n>Local Processing</div>
        <div class="allowWrap" mat-line i18n>
          Your presentation or document is modified locally and not
          sent to any external server.
        </div>
      </mat-list-item>
      <mat-list-item class="autoHeight">
        <mat-icon mat-list-icon color="accent">auto_awesome</mat-icon>
        <div mat-line i18n>Automatic References & License</div>
        <div class="allowWrap" mat-line i18n>
          When all images have been processed, you can save the modified version
          of your file with all the image sources and a license notice included.
        </div>
      </mat-list-item>
    </mat-list>

    <mark i18n
      >Please note that you have to either be the copyright owner or have
      permission from all copyright owners of all content in a file to publish
      it as OER.</mark
    >
    <p i18n>
      When you are ready, you can start with selecting the file you want to
      convert and answering some initial questions.
    </p>
    <div>
      <button
        mat-raised-button
        color="primary"
        (click)="atWelcome = false"
        #startButton
        cdkFocusInitial
      >
        Start!
      </button>
    </div>
  </div>

  <mat-horizontal-stepper
    #stepper
    linear
    *ngIf="!atWelcome"
    labelPosition="bottom"
    [formGroup]="stepperFormGroup"
    (selectionChange)="onStepChange($event)"
  >
    <!-- ****************************
    Selecting file Stepper...
    **************************** -->

    <!-- <mat-step label="Usage Disclaimer" i18n-label state="usageDisclaimer">
      <h3 i18n>Usage Disclaimer</h3>
      <p i18n>
        This web app is developed as part of a research project at RWTH Aachen
        University. It connects users with external image datasets containing
        images published under a permissive license. Images in these datasets
        are user-uploaded, and we do not have control over the returned results.
        Therefore we cannot take responsibility for or verify their content and
        licensing. Please use this tool at your discretion and, when in doubt,
        try to contact the copyright holder or seek legal advice.
        <br />
        <br />
        This web tool uses the Flickr API and Openverse API but is not endorsed
        or certified by SmugMug, Inc or Wordpress.org.
        <br />
        <br />
        As part of active research, we might collect anonymous usage data for
        this web app. Additionally, users can voluntarily provide feedback
        information that is strictly only used for improving and testing the
        functionality of this tool.
        <br />
        <br />
        By continuing, you agree to these terms and the privacy policy linked
        below.
        <br />
        <br />
        <a
          href="https://www.rwth-aachen.de/cms/root/Footer/Services/~cesv/Datenschutzerklaerung/lidx/1/"
          target="_blank"
          >Privacy Policy</a
        >
        <br />
        <br />
        <a href="https://learntech.rwth-aachen.de" target="_blank"
          >Website of the institute</a
        >
        <br />
        <a href="https://rwth-aachen.de" target="_blank"
          >Website of RWTH Aachen University</a
        >
      </p>
      <mat-checkbox #agreeCheckbox i18n>I understand and agree</mat-checkbox>
      <br /><br />
      <div>
        <mat-error *ngIf="!agreeCheckbox.checked" style="height: 1.5rem" i18n>You need to agree to these terms to continue.</mat-error>
        <div *ngIf="agreeCheckbox.checked" style="height: 1.5rem"></div>
        <button
          [disabled]="!agreeCheckbox.checked"
          mat-stroked-button
          color="primary"
          matStepperNext
          i18n
        >
          Next
        </button>
      </div>
    </mat-step> -->

    <mat-step
      label="Choose File"
      i18n-label
      state="chooseFile"
      [stepControl]="stepperFormGroup.get('chosenFile')"
    >
      <h3 i18n>Select the file you want to convert into an OER</h3>
      <h5 i18n>Supported formats are {{ getAllFileFormats() }}.</h5>
      <app-import-file (file-import)="onFileImport($event)"></app-import-file>
      <br /><br />
      <div>
        <!-- <button mat-button matStepperPrevious i18n>Back</button> -->
        <button
          [disabled]="!stepperFormGroup.get('chosenFile').valid"
          mat-stroked-button
          color="primary"
          matStepperNext
          i18n
        >
          Next
        </button>
      </div>
    </mat-step>

    <!-- *********************************
    First name and Last name Stepper...
    ********************************* -->
    <mat-step
      label="Enter Name"
      i18n-label
      state="enterUserName"
      [stepControl]="stepperFormGroup.get('userName')"
    >
      <h3 i18n>Enter your name</h3>
      <h5 i18n>
        This name will be included in the resulting license disclaimer.
      </h5>
      <mat-form-field (keydown.enter)="stepper.next()">
        <mat-label i18n>Your full name</mat-label>
        <input
          matInput
          i18n-placeholder
          placeholder="John Doe"
          formControlName="userName"
        />
      </mat-form-field>
      <div>
        <button mat-button matStepperPrevious i18n>Back</button>
        <button
          [disabled]="!stepperFormGroup.get('userName').valid"
          mat-stroked-button
          color="primary"
          matStepperNext
          i18n
        >
          Next
        </button>
      </div>
    </mat-step>

    <!-- ****************************
    license short and long forms; along with 'More info..' links added...
    **************************** -->
    <mat-step
      i18n-label
      label="Enter Target License"
      state="enterTargetLicense"
      [stepControl]="stepperFormGroup.get('targetLicense')"
    >
      <h3 i18n>Choose a license for the resulting OER</h3>
      <h5 i18n>
        For general information about open licenses visit
        <a href="https://creativecommons.org/" target="_blank"
          >creativecommons.org</a
        >
      </h5>

      <mat-form-field style="width: 100%">
        <mat-label i18n>Choose the targeted license</mat-label>
        <mat-select formControlName="targetLicense" required>
          <mat-option *ngFor="let license of licenses" [value]="license">
            {{ getLicenseShortName(license) }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <br />

      <div *ngIf="stepperFormGroup.get('targetLicense').value">
        <span i18n>Full name: </span>
        <i>{{
          getLicenseFullName(stepperFormGroup.get("targetLicense").value)
        }}</i>
        <br />
        <a
          [href]="getLicenseURL(stepperFormGroup.get('targetLicense').value)"
          target="_blank"
          i18n
          >More Info about this license</a
        >
      </div>
      <br />
      <div>
        <button mat-button matStepperPrevious i18n>Back</button>
        <button
          [disabled]="!stepperFormGroup.get('targetLicense').valid"
          mat-stroked-button
          color="primary"
          matStepperNext
          i18n
        >
          Next
        </button>
      </div>
    </mat-step>
    <!-- ************************** -->

    <mat-step
      label="Enter Legal Disclaimer"
      i18n-label
      state="enterLegalText"
      [stepControl]="stepperFormGroup.get('disclaimerSlideText')"
    >
      <h3 i18n>Edit the generated disclaimer</h3>
      <h5>
        <span i18n>This disclaimer will be included in the resulting OER.</span>
        <br />
        <span i18n>You can edit it to your liking.</span>
      </h5>
      <mat-form-field style="width: 100%">
        <mat-label i18n>Disclaimer Text</mat-label>
        <textarea
          matInput
          rows="5"
          i18n-placeholder
          placeholder="Please enter the text on the legal dislaimer slide"
          formControlName="disclaimerSlideText"
          style="height: auto"
        ></textarea>
      </mat-form-field>
      <div>
        <button mat-button matStepperPrevious i18n>Back</button>
        <button mat-stroked-button color="primary" matStepperNext i18n>
          Next
        </button>
      </div>
    </mat-step>
    <mat-step label="Additional Options" i18n-label state="additionalOptions">
      <h3 i18n>Additional Options</h3>
      <h5 i18n>
        This feature classifies images in order to suggest replacement image
        options automatically.
      </h5>
      <br />
      <!-- <h4>Auto-identify images</h4> -->
      <mat-slide-toggle #autoClassifyToggle
        ><h4 i18n>Auto-recognize images</h4></mat-slide-toggle
      >
      <p *ngIf="autoClassifyToggle.checked" class="toggleDescText" i18n>
        If you select an image and choose to search for a replacement the tool
        will automatically generate possible search terms and start the image
        search with those.
      </p>
      <p *ngIf="!autoClassifyToggle.checked" class="toggleDescText" i18n>
        The tool will not automatically search for suggested search terms when
        you choose to search for a replacement for an image.
      </p>
      <br />
      <button mat-button matStepperPrevious i18n>Back</button>
      <button
        mat-button
        mat-raised-button
        color="primary"
        (click)="processAdditionalOptions(autoClassifyToggle.checked)"
        i18n
      >
        Finish
      </button>
    </mat-step>
    <!-- Icon overrides. -->
    <ng-template matStepperIcon="usageDisclaimer">
      <mat-icon>handshake</mat-icon>
    </ng-template>
    <ng-template matStepperIcon="chooseFile">
      <mat-icon>insert_drive_file</mat-icon>
    </ng-template>
    <ng-template matStepperIcon="enterUserName">
      <mat-icon>person</mat-icon>
    </ng-template>
    <ng-template matStepperIcon="enterTargetLicense">
      <mat-icon>gavel</mat-icon>
    </ng-template>
    <ng-template matStepperIcon="enterLegalText">
      <mat-icon>assignment_late</mat-icon>
    </ng-template>
    <ng-template matStepperIcon="askForSearch">
      <mat-icon>help</mat-icon>
    </ng-template>
    <ng-template matStepperIcon="searchDatabase">
      <mat-icon>image_search</mat-icon>
    </ng-template>
  </mat-horizontal-stepper>
</div>
